//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      traderData: {
        traderCount: 0,
        regulatorCount: 0,
        languageCount: 0,
        countryCount: 0
      }
    }
  },
  mounted () {
    this.getExchange()
  },
  methods: {
    // 获取交易商数据
    async getExchange () {
      try {
        const res = await this.$api.login.userExchange()
        this.traderData = res || {}
      } catch (err) {}
    }
  }
}
